import { render } from "./FilmProjectsRoadmapPath.vue?vue&type=template&id=04592616&scoped=true"
import script from "./FilmProjectsRoadmapPath.vue?vue&type=script&lang=js"
export * from "./FilmProjectsRoadmapPath.vue?vue&type=script&lang=js"

import "./FilmProjectsRoadmapPath.vue?vue&type=style&index=0&id=04592616&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04592616"]])

export default __exports__